import React, { Component, PropTypes } from 'react';
import page from 'page';
import { PromiseState } from 'react-refetch';
import { PromiseStateContainer } from 'components';
import { SearchBar, Hero, SearchResult } from '../../components';
import { appConnect } from '../../utils/connect';
import { filterItemsByRoute, orderByTitle } from '../../utils/resources';

class Resource extends Component {
  static defaultProps = {
    items: [],
    route: null
  };

  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        className: PropTypes.string,
        title: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired
      })
    ),
    route: PropTypes.string,
    resourcesFetch: PropTypes.instanceOf(PromiseState).isRequired
  };

  state = {
    search: ''
  };

  componentWillReceiveProps({ route }) {
    this.initializeState(route);
  }

  initializeState(route) {
    if (route !== 'home') {
      this.setState({ search: '' });
    }
  }

  searchHandler = event => {
    const { value } = event.target;
    this.setState({ search: value });
    if (value.length) {
      page('/resources');
    }
  };

  render() {
    const { items, route, resourcesFetch } = this.props;
    const { search } = this.state;
    return (
      <div>
        <section className="hero">
          <Hero />
          <SearchBar
            onInputChange={this.searchHandler}
            route={route}
            firstTabIsSelected={Boolean(search.length)}
            searchValue={search}
          />
        </section>
        <section className="resources-container">
          <div className="container">
            {items
              ? <SearchResult
                  items={filterItemsByRoute(items, route)}
                  itemsForSearching={orderByTitle(items)}
                  search={search}
                />
              : <PromiseStateContainer
                  ps={PromiseState.race([resourcesFetch])}
                  onFulFillment={resources => (
                    <SearchResult
                      items={filterItemsByRoute(resources, route)}
                      itemsForSearching={orderByTitle(items)}
                      search={search}
                    />
                  )}
                />}
          </div>
        </section>
      </div>
    );
  }
}

export default appConnect(Resource);



// WEBPACK FOOTER //
// ./src/pages/resources/containers/Resource/Resource.js